import { render, staticRenderFns } from "./UpdateSugModal.vue?vue&type=template&id=a983cde8"
import script from "./UpdateSugModal.vue?vue&type=script&lang=js"
export * from "./UpdateSugModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports